import { render, staticRenderFns } from "./AddCif.vue?vue&type=template&id=6055901f&scoped=true"
import script from "./AddCif.vue?vue&type=script&lang=js"
export * from "./AddCif.vue?vue&type=script&lang=js"
import style0 from "./AddCif.vue?vue&type=style&index=0&id=6055901f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055901f",
  null
  
)

export default component.exports